import { RefCallback, useCallback, useEffect, useRef } from "react";
import { debounce } from "./debounce";

export function useResizeObserver(callback: ResizeObserverCallback): RefCallback<HTMLElement> {
  const observer = useRef<ResizeObserver>(new ResizeObserver(debounce(callback, 50)));
  const itemRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const obs = observer.current;
    if (itemRef.current) {
      obs.observe(itemRef.current);
    }
    return () => {
      obs.disconnect();
    };
  }, []);

  return useCallback((node) => {
    if (node) {
      itemRef.current = node;
      observer.current.observe(node);
    }
  }, []);
}
